<template>
  <div id="sidebar-admin">
    <div class="sidebar shadow">
      <router-link to="/agentclound-management/about"><i class="fas fa-map-marked-alt"></i> About Management
      </router-link>
      <router-link to="/agentclound-management/customer-list"><i class="far fa-address-card"></i> Customer List</router-link>
      <router-link to="/agentclound-management/user-list"><i class="fas fa-user-cog"></i> User Management</router-link>
      <router-link to="/agentclound-management/export-log"><i class="fas fa-download"></i> Export Log</router-link>
    </div>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped>
</style>